// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"694":"eb036270","787":"54c772cc"}[chunkId] + ".chunk.js";
};